import {NewsBody} from "./news.body";
import {InterfaceNews, InterfaceNewsItem} from "../../interface/press-center/interface.news";
import {activationClasses, numberSystemDecimal} from "../../common/consts";
import {NewsPageService} from "./service/news.page.service";
import {NewsStore} from "../../store/news.store";
import {NewsPage} from "./news.page";

export class NewsCategories {
    public currentCategoryId: number;
    private newsCategories: HTMLElement[];
    private categoryIdWithLoadedData: number;

    constructor(
        private container: HTMLElement,
        private categories: { Id: number, Name: string }[],
        private loader: HTMLElement | null,
        private pressCenterNews: HTMLElement[],
        private newsStore: NewsStore
    ) {
        this.newsCategories = [];
        const params = new URLSearchParams(window.location.search);
        const currentCategoryId: string | null = params.get('categoryId');
        this.currentCategoryId = -1;
        if (currentCategoryId) {
            this.currentCategoryId = parseInt(currentCategoryId, numberSystemDecimal);
        }
        this.categoryIdWithLoadedData = this.currentCategoryId;
    }

    public initialize(): void {
        this.renderMenu();
        this.newsCategories
            = Array.prototype.slice.call(this.container.querySelectorAll('[data-news-category]'));

        this.newsCategories.forEach((category: HTMLElement) => {
            if (category.dataset.newsCategory) {
                const categoryId = parseInt(category.dataset.newsCategory, numberSystemDecimal);
                category.classList.remove(activationClasses.active);
                if (this.currentCategoryId === categoryId) {
                    category.classList.add(activationClasses.active);
                }
            }
            category.addEventListener('click', () => {
                const newsCategoryId = category.dataset.newsCategory
                    ? parseInt(category.dataset.newsCategory, numberSystemDecimal)
                    : null

                // new NewsPageService(this.loader).getNewsByCategoryId(newsCategoryId,'true') / на случай когда нужно будет фильтровать важные
                //     .then((dataFeaturedNews: InterfaceNews | null) => {

                    if (category.dataset.newsCategory) {
                        this.currentCategoryId = parseInt(category.dataset.newsCategory, numberSystemDecimal);
                    }

                    this.newsCategories.forEach((categorySoughtAfter: HTMLElement) => {
                        categorySoughtAfter.classList.remove(activationClasses.active);

                        if (categorySoughtAfter.dataset.newsCategory === category.dataset.newsCategory) {
                            categorySoughtAfter.classList.add(activationClasses.active);
                        }
                    })
                    if (this.currentCategoryId === -1) {
                        history.pushState(null, '', location.pathname);
                    }
                    if (this.categoryIdWithLoadedData !== this.currentCategoryId) {
                        new NewsPageService(this.loader).getNewsByCategoryId(newsCategoryId)
                          .then((data: InterfaceNews | null) => {
                              const dataFeaturedNews: InterfaceNewsItem[] = this.newsStore.getFeaturedNews();
                              if (data && dataFeaturedNews) {
                                  new NewsPage(this.newsStore, this.loader, this.pressCenterNews, data.TotalCount)
                                    .initialize();
                                  this.pressCenterNews.forEach((item: HTMLElement) => new NewsBody(
                                    item,
                                    data.News,
                                    data.TotalCount,
                                    dataFeaturedNews,
                                    this.newsStore,
                                    this.loader,
                                    this.pressCenterNews
                                  ).initialize());
                              }
                              this.categoryIdWithLoadedData = this.currentCategoryId;
                          });
                    }
                // });
            });
        })
    }
    private renderMenu(): void {
        let categories = `
            <div class="press-center__filter-button swiper-slide swiper-slide--kind-height active"
                 data-news-category="-1"><h6>Все</h6>
            </div>
        `;

        this.categories.forEach((category: { Id: number, Name: string }) => {

            categories += `
                <div class="press-center__filter-button swiper-slide swiper-slide--kind-height"
                     data-news-category="${category.Id}"><h6>${category.Name}</h6>
                </div>
            `
        });
        this.container.innerHTML = categories;
    }
}
